import { render } from "./PieceActionRow.vue?vue&type=template&id=231df4d8"
import script from "./PieceActionRow.vue?vue&type=script&lang=js"
export * from "./PieceActionRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__